export const INTERVIEW_SET_TYPES = {
    PHONE: 'PHONE'
};

export const INTERVIEW_SET_CATEGORIES = {
    IN_PERSON: 'IN_PERSON'
};